<div class="container">


  <h2 class="content-heading">
    <button class="btn btn-sm btn-outline-secondary float-right" (click)="add()">
      <i class="fa fa-plus mr-5"></i>Add User
    </button>
    User Management
  </h2>


  <div class="block">

    <!--
      <div class="block-header block-header-default">
          <h3 class="block-title"></h3>
      </div>
    -->

    <div class="block-content">
      <div class="table-responsive ">
        <table class="table table-striped table-vcenter table-sm">
          <thead>
            <tr>
                <th>First Name</th>
                <th>Last Name</th>
                <th>User Name</th>
                <th>Role</th>
                <th>Status</th>
              <th>Registration Status</th>
              <th class="text-right" style="width: 100px;">Actions</th>
            </tr>
          </thead>
          <tbody>


            <tr *ngFor="let obj of data">
                <td>{{obj.FirstName}}</td>
                <td>{{obj.LastName}}</td>
                <td>{{obj.UserName}}</td>
                <td>{{obj.Role}}</td>
                <td>
                    <span *ngIf="obj.IsActive == true">Active</span>
                    <span *ngIf="obj.IsActive != true">Inactive</span>
                </td>
              <td>{{obj.RegistrationStatus}}</td>
              <td class="text-right">
                <div class="btn-group">
                  <button *ngIf="obj.RegistrationStatusId == 0" type="button" class="btn btn-sm btn-secondary js-tooltip-enabled" data-toggle="tooltip" title="" data-original-title="Edit"
                    (click)="approveRegistration(obj)">
                    Approve
                  </button>
                  <button type="button" class="btn btn-sm btn-secondary js-tooltip-enabled" data-toggle="tooltip" title="" data-original-title="Edit" (click)="edit(obj)">
                      <i class="fa fa-pencil"></i>
                  </button>
                </div>
              </td>
            </tr>

          </tbody>
        </table>
      </div>


    </div>

  </div>

</div>
